import React from "react";
import { User } from "../../slices/usersSlice";
import UserManagementActionMenu from "../UserManagementActionMenu/UserManagementActionMenu";
import { Column } from "@/components/Datatable/types";

interface CreateUsersColumnsProps {
  handleEdit: (uuid: string) => void;
}

export function createUsersColumns({
  handleEdit,
}: CreateUsersColumnsProps): Column<User>[] {
  return [
    {
      header: "First Name",
      accessorKey: "firstName",
      enableSorting: true,
    },
    {
      header: "Last Name",
      accessorKey: "lastName",
      enableSorting: true,
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
    },
    {
      header: "Role",
      accessorKey: "roleLabel",
      enableSorting: true,
      cell: ({ row }) => {
        const roleLabel = row.original.roleLabel;
        return roleLabel || <span className="text-muted-foreground">—</span>;
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const userItem = row.original;

        return (
          <UserManagementActionMenu
            employeeUuid={userItem.employeeUuid || ""}
            onEdit={handleEdit}
          />
        );
      },
    },
  ];
}
